import { getEnumValues } from './get-enum-values';
export enum StaffRole{
	Admin='admin',
	HeadCoach='head-coach',
	AssistantCoach='assistant-coach',
}
export const StaffRoleValues = getEnumValues<StaffRole>(StaffRole)